export const darkTheme = {
  bg: '#171C18',
  card: '#202721',
  text: '#F1F3EF',
  subtext: '#AAB4AA',
  accent: '#A9BEA5',
  sidebarAccent: '#849B80',
  surfaceMuted: '#282F29',
  success: '#8FC49A',
  danger: '#E58B88'
}

export const lightTheme = {
  bg: '#F4F5F0',
  card: '#FFFFFF',
  text: '#27332A',
  subtext: '#69756B',
  accent: '#667D68',
  sidebarAccent: '#526A55',
  surfaceMuted: '#F0F3EE',
  success: '#34734A',
  danger: '#B34F4C'
}
